import { render, staticRenderFns } from "./spam.vue?vue&type=template&id=2ae7ca55"
import script from "./spam.vue?vue&type=script&lang=js"
export * from "./spam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports